
<template>
  <span class="m-0 p-0" style="display:inline-table">
    <span v-show="expanded == false" class="m-0 p-1" @click="expand" style="display:table;">
      <i class="icon-info22 info-note-icon"></i>
    </span>
    <div v-show="expanded == true" class="m-0 p-1 info-note">
      <i class="icon-info22 info-note-icon" @click="collapse"></i>
      <button type="button" class="close" @click="collapse"><span>×</span></button>
      <span v-show="expanded == true" class="ml-1 mr-1 animated fadeIn">{{text}}</span>
    </div>
  </span>
</template>

<script>

  var expanded = false;

  export default {

    name: 'info-note',
		components: {
    },
    data(){
      return {
        expanded
      }
    },
    props: [
      'text',
      
    ],
    methods: {
      expand() {
        this.expanded = true;
        //this.$forceUpdate();
      },
      collapse() {
        this.expanded = false;
      }

    },
    created() {
      
    },
    mounted() {
      
    }
}
</script>
<style scoped>

  .info-note-icon{
    cursor:pointer;
  }

  .info-note {
    background-color: rgb(247, 247, 249);
    border-color: #ccc;
    color: black;
  }

  .alert[class*="alert-styled-"]::after {
    color: black;
  }

</style>



// WEBPACK FOOTER //
// src/components/notes/info-note.vue